import { countries } from 'countries-list';
export const supportedCountryCodes = [
    'US',
    'BR',
    'SE',
    'FR',
    'IT',
    'IN',
    'GB',
    'CA',
    'PK',
    'DE',
    'ES',
    'AE',
    'SA',
    'VN',
    'PL',
    'JP',
    'FI',
];
// useful for sending notifs to users without store items/giveaways
export const unsupportedCountryCodes = Object.keys(countries).filter((code) => !supportedCountryCodes.includes(code));
export const countryCodes = Object.keys(countries);
